var exports = {
  "Pf": "AvatarUploader.module__label___UUZTb2",
  "GC": "AvatarUploader.module__buttonGroup___UUZTb2",
  "Ng": "AvatarUploader.module__buttonGroupAfterMode___UUZTb2",
  "gJ": "AvatarUploader.module__errorMessage___UUZTb2",
  "lB": "AvatarUploader.module__spacedParagraph___UUZTb2",
};

module.exports = exports;
